const BUBBLE_IDS_KEY = 'cosafe:animatedBubbleIdentities';

function getBubbleIds(): Set<string> {
  try {
    const raw = localStorage.getItem(BUBBLE_IDS_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

function saveBubbleIds(set: Set<string>): void {
  try {
    localStorage.setItem(BUBBLE_IDS_KEY, JSON.stringify([...set]));
  } catch {
    // localStorage unavailable — silently skip
  }
}

export function hasBubbleId(id: string): boolean {
  return getBubbleIds().has(id);
}

export function addBubbleId(id: string): void {
  const set = getBubbleIds();
  set.add(id);
  saveBubbleIds(set);
}

export function deleteBubbleId(id: string): void {
  const set = getBubbleIds();
  set.delete(id);
  saveBubbleIds(set);
}

export function deleteBubbleIdsForIdentity(identity: string): void {
  const prefix = `${identity}:`;
  const next = new Set(
    [...getBubbleIds()].filter(key => key !== identity && !key.startsWith(prefix))
  );
  saveBubbleIds(next);
}
